<template>
    <div class="form-login-signup">
        <p class="mb-8">Do you already have an account?</p>
        <button-primary class="mr-4" buttonRoute="/signup" buttonText="Signup"></button-primary>
        <button-primary class="mr-4" buttonRoute="/login" buttonText="Login"></button-primary>
    </div>
</template>

<script>
export default {
    name: 'FormLoginSignup',
};
</script>
